/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_ANSWERS } from "./actionTypes"
import { apiError, listAnswersSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getAnswers } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(getAnswers, request.payload.idQuestion)
    if (response == undefined) throw new Error("API error")
    yield put(listAnswersSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* answersListSaga() {
  yield takeEvery(LIST_ANSWERS, list)
}

export default answersListSaga
